import { render, staticRenderFns } from "./DisableRequests.vue?vue&type=template&id=237ee371&scoped=true"
import script from "./DisableRequests.vue?vue&type=script&lang=js"
export * from "./DisableRequests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "237ee371",
  null
  
)

export default component.exports